import useLookupListData from "@app/data-hooks/use-lookup-list-data.ts";
import useWorkLocationData from "@app/data-hooks/use-work-location-data.ts";
import { Button, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { useForm } from "@tanstack/react-form";
import { Dialog, QueryStatusRouter, Select } from "bi-lib";

interface Props {
    open: boolean;
    onClose: () => void;
    assignmentId: number;
    locationId?: number;
}

export default function AssignmentWorkLocationModal({ open, onClose, assignmentId, locationId }: Props) {
    const { workLocation, createWorkLocation } = useWorkLocationData({ locationId: open ? locationId : undefined });
    const { stateCodeList } = useLookupListData();

    const form = useForm({
        defaultValues: {
            stateId: workLocation.data?.stateCodeId,
            cityName: workLocation.data?.city,
        },
        onSubmit: async ({ value }) => {
            await createWorkLocation.mutateAsync({
                assignmentId,
                workLocationId: locationId?.toString(),
                stateId: value.stateId?.toString(),
                cityName: value.cityName,
            });
            onClose();
        },
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"sm"} fullWidth>
            <DialogTitle>{locationId != undefined ? "Update" : "Create"} Work Location</DialogTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    void form.handleSubmit();
                }}
            >
                <DialogContent>
                    <Stack spacing={1}>
                        <QueryStatusRouter queryHook={stateCodeList}>
                            <form.Field name={"stateId"}>
                                {(field) => (
                                    <Select
                                        label={"Select State"}
                                        value={field.state.value}
                                        onChange={(e) => field.handleChange(e)}
                                        options={stateCodeList.data?.map((x) => ({
                                            label: x.stateName,
                                            value: x.stateCodeId,
                                        }))}
                                    />
                                )}
                            </form.Field>
                        </QueryStatusRouter>
                        <form.Field name={"cityName"}>
                            {(field) => (
                                <TextField
                                    label={"City Name"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                />
                            )}
                        </form.Field>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant={"outlined"} onClick={onClose}>
                        Close
                    </Button>
                    <Button type={"submit"} variant={"contained"}>
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
